import React, { useState } from "react";
import { Box, Typography, IconButton, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const ExpandableContent = ({
  defaultContent,
  expandedContent,
  initiallyExpanded = false,
}) => {
  const [expanded, setExpanded] = useState(initiallyExpanded);

  const toggleExpanded = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Box sx={{}}>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
        }}
      >
        <Typography>
          {defaultContent}

          <IconButton onClick={toggleExpanded}>
            {expanded ? (
              <ExpandLessIcon fontSize="medium" />
            ) : (
              <ExpandMoreIcon fontSize="medium" />
            )}
          </IconButton>
        </Typography>
      </Box>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Typography variant="body2" sx={{}}>
          {expandedContent}
        </Typography>
      </Collapse>
    </Box>
  );
};

export default ExpandableContent;
